import {mainQuery} from '@github-ui/react-core/future/main-query'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {reposCommitActivityAppBuilder} from '../config/app-builder'
import type {CommitMetricDataPoints} from '../types'

export type CommitActivityResponse = {
  graphDataPath: string
  commitData: CommitMetricDataPoints[]
}

const useExistingUrl = isFeatureEnabled('repos_insights_remove_new_url')

export const commitActivityRoute = reposCommitActivityAppBuilder.createQueryRouteConfig('commitActivityRoute', {
  path: useExistingUrl ? '/:owner/:repo/graphs/commit-activity' : '/:owner/:repo/graphs/commit-activity-new',
  queries: [mainQuery<CommitActivityResponse>()],
})
